<template>
  <ContextColorProvider class="portability" context="trade">
    <PortabilityInformation
      v-if="step === PortabilityRequestSteps.Information"
      @on-change-step="handleChangeStep"
    />
    <PortabilityRequestConclusion
      v-else-if="step === PortabilityRequestSteps.Conclusion"
    />
  </ContextColorProvider>
</template>

<script lang="ts" setup>
import { ref, provide } from 'vue';

import { ContextColorProvider } from '@warrenbrasil/nebraska-web';

import { PortabilityInformation } from './components/PortabilityInformation';
import { PortabilityRequestConclusion } from './components/PortabilityRequestConclusion';

import {
  PortabilityRequest,
  PortabilityRequestConclusionResponse
} from '@/modules/trade/services/portability';
import { PortabilityRequestSteps } from './types';

const step = ref<PortabilityRequestSteps>(PortabilityRequestSteps.Information);
const portabilityRequest = ref<PortabilityRequest | null>(null);
const portabilityRequestConclusion =
  ref<PortabilityRequestConclusionResponse | null>(null);

provide('portabilityRequest', portabilityRequest);
provide('portabilityRequestConclusion', portabilityRequestConclusion);

const handleChangeStep = (newStep: PortabilityRequestSteps) => {
  step.value = newStep;
};
</script>
<style lang="less" scoped>
.portability {
  display: flex;
  min-height: 100vh;
  flex-direction: column;

  &__main {
    padding: @size-spacing-x1000 @size-spacing-x500 @size-spacing-x1200
      @size-spacing-x500;
    max-width: 592px;
    width: 100%;
    margin: 0 auto;
    box-sizing: content-box;
    .to-lg({ padding: @size-spacing-x400 @size-spacing-x400 @size-spacing-x1200 @size-spacing-x400; });
  }

  &__footer {
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: @background-secondary;
  }

  &__heading {
    margin-bottom: @size-spacing-x800;
  }

  &__helper-wrapper {
    flex-grow: 1;
    display: flex;
  }

  &__helper {
    display: block;
    margin: 0 auto;
    align-self: center;
  }
}
</style>
